import { distMi } from "./followedFires";

// Road closures (County EM + WSDOT) within the evac's radius + 3 mi.
export function closuresNearEvac(alert, closures = [], wsdotAlerts = []) {
  if (alert?.latitude == null) return [];
  const reach = (Number(alert.radius_mi) || 5) + 3;
  const closureRe = /closed|closure/i;
  const em = closures
    .filter((c) => c.latitude != null)
    .map((c) => ({
      id: c.id, name: c.name || "Road closure", milepost: c.milepost,
      lat: c.latitude, lon: c.longitude, src: "County EM",
    }));
  const dot = wsdotAlerts
    .filter((r) => r.start_lat != null && closureRe.test(`${r.category || ""} ${r.headline || ""}`))
    .map((r) => ({
      id: r.id, name: r.road ? `SR ${r.road}` : "Highway", milepost: r.start_milepost,
      lat: r.start_lat, lon: r.start_lon, src: "WSDOT", headline: r.headline,
    }));
  return [...em, ...dot]
    .map((c) => ({ ...c, _d: distMi(alert.latitude, alert.longitude, c.lat, c.lon) }))
    .filter((c) => c._d <= reach)
    .sort((x, y) => x._d - y._d)
    .slice(0, 12);
}
